import React, { useState, useEffect } from 'react';
import { Button } from '../common/Button';
import * as api from '../../api/user-app-api'; // ✅ your backend API file

export const ProfileScreen = ({ setView, setIsLoggedIn, setUser }) => {
    const [profile, setProfile] = useState({
        id: '',
        name: '',
        phone: '',
        email: '',
    });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    // ✅ Load profile data from backend
    const loadProfile = async () => {
        try {
            const userId = localStorage.getItem('userId');
            if (!userId) throw new Error("User not logged in.");
console.log(userId);
            const response = await api.fetchUserProfile({ id: userId }); // Requires: /users/get_profile.php
            if (response.data.status === 'success') {
                setProfile(response.data.profile);
            } else {
                console.warn(response.data.message);
            }
        } catch (error) {
            console.error("Error loading profile:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadProfile();
    }, []);

    // ✅ Handle profile save
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            const response = await api.updateUserProfile(profile); // Requires: /users/update_profile.php
            if (response.data.status === 'success') {
                localStorage.removeItem('needsProfileCompletion');
                alert('Profile updated successfully!');
                setView('Dashboard');
            } else {
                alert(response.data.message || 'Failed to save profile.');
            }
        } catch (error) {
            console.error("Error saving profile:", error);
            alert('Error saving profile. Please try again.');
        } finally {
            setIsSaving(false);
        }
    };

    // ✅ Logout logic
    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userId');
        setIsLoggedIn(false);
        setView('login');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile(prev => ({ ...prev, [name]: value }));
    };

    if (isLoading) {
        return <div className="p-4">Loading profile...</div>;
    }

    return (
        <div className="relative h-[calc(100vh-80px)] overflow-y-scroll scrollbar-thin scrollbar-custom pb-24">

        <div className="p-4 pt-0 pb-28">
            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                    <input
                        type="text"
                        name="name"
                        value={profile.name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-[#01a499]"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                    <input
                        type="tel"
                        name="phone"
                        value={profile.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-[#01a499]"
                        required
                        disabled
                    />
                    <p className="text-xs text-gray-500 mt-1">Phone number cannot be changed</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={profile.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-[#01a499]"
                    />
                </div>

                <div className="pt-4">
                    <Button onClick={() => setView('myAddress', { returnTo: 'cart' })} type="button" className="mb-4 !bg-gray-600">
                        Manage My Addresses
                    </Button>

                    <Button onClick={() => setView('orderHistory')} type="button" className="mb-4 !bg-gray-600">
                        View Order History
                    </Button>

                    <Button onClick={() => setView('help')} type="button" className="mb-4 !bg-gray-600">
                        Help & Support
                    </Button>

                    <Button onClick={() => setView('privacyPolicy')} type="button" className="mb-4 !bg-gray-600">
                        Privacy Policy
                    </Button>

                    <Button onClick={handleLogout} type="button" className="!bg-red-600">
                        Logout
                    </Button>
                    <div style={{height:100}}/>
                </div>
            </form>

            <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t pb-7">
                <Button type="submit" onClick={handleSubmit} disabled={isSaving}>
                    {isSaving ? 'Saving Changes...' : 'Save Changes'}
                </Button>
            </div>
        </div>
        </div>
    );
};
